import React, { Component } from 'react'
import { connect } from 'react-redux'
import pt from 'prop-types'
import Item from './SectionItem'
import { getBEMClasses } from '../../util/text'
import { setKnobsPanelTopMargin, toggleFeedsFilter, toggleFeedsHeight } from '../../modules/ui'
import { debounce, get } from 'lodash-es'
import { getCustomMenuOptions, mobileBreakpoint } from '../../util/settings'
import { makeGetFeedById, makeGetProfileUserByUsername } from '../../modules/entities'
import ViewOptionsBar from '../ViewOptionsBar/ViewOptionsBar'
import { requestCustomFeeds, requestSavedFeeds, requestPickedFeeds } from '../../modules/userContent'
import {
  requestFeedsSavedToSectionsProfile,
  requestFeedsSavedToSectionsFeeder,
  requestCustomFeedSections
} from '../../modules/feeds'
import DotMenu from '../icon/DotMenu'
import SectionsMenu from '../SectionsMenu/SectionsMenu'
import Fade from '../Fade/Fade'
import './index.scss'

class FeedSections extends Component {
  state = {
    isFeedsFilterToggled: false,
    isMobile: false,
    optionsShown: false,
    itemsOrder: 'custom',
    showFeedOptions: false,
    isMenuOpen: false
  }

  setOrder = options => {
    // Action to order feeds

    const order = (options && options.order) || 'custom'
    if (order === this.state.itemsOrder) {
      return
    }
    this.setState(
      {
        itemsOrder: order
      },
      () => {
        // action to get ordered items
      }
    )
  }

  switchOptionsShown = options => {
    this.setState({
      optionsShown: options.state,
      viewOptionsType: options.item && options.item.toLowerCase()
    })
  }

  componentDidMount() {
    const {
      requestCustomFeeds,
      user,
      requestFeedsSavedToSectionsProfile,
      requestFeedsSavedToSectionsFeeder,
      requestCustomFeedSections,
      profileId
    } = this.props
    const isMobile = window.innerWidth <= mobileBreakpoint

    requestCustomFeeds({
      userId: profileId
    })
    if (user && user.id) {
      requestFeedsSavedToSectionsProfile()
      requestFeedsSavedToSectionsFeeder()
      requestCustomFeedSections({
        userId: user.id,
        home: 0
      })
    }
    this.setState({ isMobile })
    !isMobile &&
      !this.props.isMouseEntered &&
      window.addEventListener('mouseover', debounce(this.handleMouseOverExpander, 10))
  }

  componentWillUnmount() {
    this.props.toggleFeedsHeight(62)
    !this.state.isMobile &&
      !this.props.isMouseEntered &&
      window.removeEventListener('mouseover', this.handleMouseOverExpander)
  }

  componentDidUpdate() {
    const clientHeight = get(this.filter, 'filter.clientHeight')
    if (clientHeight && clientHeight !== this.props.ui.feedsHeight) {
      this.props.toggleFeedsHeight(document.querySelector('.feeds-filter').clientHeight)
    }
  }

  handleMouseOverExpander = e => {
    const { relatedTarget, clientX } = e
    const { toggleFeedsFilter, ui } = this.props
    const { isFeedsListExpanded } = ui
    const { isFeedsFilterToggled } = this.state
    const isPartOfFeedExpander = target => target === this.feedExpander || target === this.feedExpanderArrow

    // Check if there is feed expander div

    if (isPartOfFeedExpander(relatedTarget) && this.feedExpander) {
      if (!isFeedsListExpanded) return toggleFeedsFilter(true)
    }

    const isPartOfTheContainerOrInside = target =>
      target.classList.contains('search-page__feeds-filter-container') ||
      target.classList.contains('knobs-panel') ||
      target.classList.contains('feed-description')
    const isOutsideOfTheContainer = target =>
      target.classList.contains('search-page__cards') || target.classList.contains('page-layout')
    const isTargetInsideTheContainer = target => {
      if (isPartOfFeedExpander(target) || isPartOfTheContainerOrInside(target)) return true
      if (isOutsideOfTheContainer(target)) return false
      const { parentNode } = target
      if (parentNode) return isTargetInsideTheContainer(parentNode)
      return false
    }

    const isLeftOrRightOfTheContainer = xCoord => {
      const searchPageContainer = document.querySelector('.search-page__cards')
      if (searchPageContainer) {
        const { offsetLeft, offsetWidth } = searchPageContainer
        const offsetRight = offsetWidth + offsetLeft
        return xCoord < offsetLeft || xCoord > offsetRight
      }
      return false
    }

    if (relatedTarget) {
      if (isFeedsListExpanded && !isFeedsFilterToggled) {
        if (!isTargetInsideTheContainer(relatedTarget) || isLeftOrRightOfTheContainer(clientX)) {
          return toggleFeedsFilter(false)
        }
      }
    }
  }

  getTo(profileName, o, index, subIndex) {
    const { to, url } = o
    let customUrl = ''
    if (profileName && (url === '/' || url === '/picks' || url === '/collections' || url === '/saved')) {
      customUrl = url
    }
    return (profileName ? '/@' + profileName : '') + (customUrl || get(to, 'pathname', to))
  }

  switchMenu = () => {
    this.setState(({ isMenuOpen }) => ({
      isMenuOpen: !isMenuOpen
    }))
  }

  render() {
    const {
      mods,
      options,
      ui,
      isMouseEntered,
      isStatic = false,
      profileName,
      switchViewSettings,
      switchViewOptions,
      viewSettings,
      user,
      isFloatingButtonPressed,
      isInProfile,
      isHome,
      type,
      requestCustomFeeds,
      requestSavedFeeds,
      requestPickedFeeds,
      feedsInSectionsFeeder,
      customFeedSections
    } = this.props

    const feedOptions = [
      {
        name: 'picked',
        text: 'Picked',
        action: e => {
          requestPickedFeeds({
            userId: user.id
          })
        }
      },
      {
        name: 'created',
        text: 'Created',
        action: e => {
          requestCustomFeeds({
            userId: user.id
          })
        }
      },
      {
        name: 'saved',
        text: 'Saved',
        action: e => {
          requestSavedFeeds({
            userId: user.id
          })
        }
      }
    ]
    const { isFeedsListExpanded } = ui
    const isHeaderScrolling = mods && mods.includes('header-scrolling')

    return (
      <>
        <div
          className={
            getBEMClasses('feeds-filter', mods) +
            (!isStatic && !(profileName && isFeedsListExpanded) ? ' feeds-filter--with-card' : '') +
            (isFeedsListExpanded ? ' feeds-filter--expanded' : '') +
            (type ? ' feeds-filter--' + type : '')
          }
          ref={filter => {
            this.filter = filter
          }}
        >
          <div className={getBEMClasses('feeds-filter__left-container', mods)}>
            <div
              className={
                getBEMClasses('feeds-filter__list', mods) +
                (isFeedsListExpanded ? '  feeds-filter__list--expanded' : '') +
                (!isStatic ? ' feeds-filter__list--with-card' : '')
              }
            >
              {!profileName && !isInProfile ? (
                <div className="feeds-filter__section feeds-filter__section--first">
                  {user ? (
                    <Item
                      mods={mods}
                      exact
                      isScrollingMode={isHeaderScrolling}
                      ui={ui}
                      isMouseEntered={isMouseEntered}
                      switchViewSettings={switchViewSettings}
                      switchViewOptions={switchViewOptions}
                      viewSettings={viewSettings}
                      switchOptionsShown={this.switchOptionsShown}
                      isCollectionViewBarShown={this.state.optionsShown}
                      type={type}
                      text={'Saved'}
                    />
                  ) : null}
                  <Item
                    mods={mods}
                    to={'/home'}
                    exact
                    isScrollingMode={isHeaderScrolling}
                    ui={ui}
                    isMouseEntered={isMouseEntered}
                    switchViewSettings={switchViewSettings}
                    switchViewOptions={switchViewOptions}
                    viewSettings={viewSettings}
                    switchOptionsShown={this.switchOptionsShown}
                    isCollectionViewBarShown={this.state.optionsShown}
                    type={type}
                    text={'Home'}
                  />
                </div>
              ) : null}

              {options.map((option, index) => {
                const { option: innerOption, feeds } = option
                return (
                  <div
                    key={innerOption.get('id', index)}
                    className={
                      'feeds-filter__section' + (isFeedsListExpanded ? ' feeds-filter__section--expanded' : '')
                    }
                  >
                    {!!innerOption.get('name') && (
                      <div
                        className={
                          'feeds-filter__section-name' +
                          (isFeedsListExpanded ? ' feeds-filter__section-name--expanded' : '') +
                          (isHeaderScrolling ? ' feeds-filter__section-name--header-scrolling' : '')
                        }
                      >
                        {innerOption.get('name')}
                      </div>
                    )}
                    {isFeedsListExpanded ? (
                      <div className="feeds-filter__section-items feeds-filter__section-items--expanded">
                        {getCustomMenuOptions({ feeds }).map((o, subIndex) => {
                          if (o) {
                            return (
                              <Item
                                {...o}
                                key={`${o.to}-${subIndex}`}
                                mods={mods}
                                to={this.getTo(profileName, o, index, subIndex)}
                                exact
                                isScrollingMode={isHeaderScrolling}
                                ui={ui}
                                isMouseEntered={isMouseEntered}
                                switchViewSettings={switchViewSettings}
                                switchViewOptions={switchViewOptions}
                                viewSettings={viewSettings}
                                switchOptionsShown={this.switchOptionsShown}
                                isCollectionViewBarShown={this.state.optionsShown}
                                type={type}
                              />
                            )
                          } else {
                            return null
                          }
                        })}
                      </div>
                    ) : (
                      getCustomMenuOptions({ feeds }).map((o, subIndex) => {
                        if (o) {
                          return (
                            <Item
                              {...o}
                              key={`${o.to}-${subIndex}`}
                              mods={mods}
                              to={this.getTo(profileName, o, index, subIndex)}
                              exact
                              isScrollingMode={isHeaderScrolling}
                              ui={ui}
                              isMouseEntered={isMouseEntered}
                              hoverParent={this.props.hoverParent}
                              switchViewSettings={switchViewSettings}
                              switchViewOptions={switchViewOptions}
                              viewSettings={viewSettings}
                              isFloatingButtonPressed={isFloatingButtonPressed}
                              switchOptionsShown={this.switchOptionsShown}
                              isCollectionViewBarShown={this.state.optionsShown}
                            />
                          )
                        }
                      })
                    )}
                  </div>
                )
              })}
              {isInProfile &&
                customFeedSections.map((option, index) => {
                  return (
                    <div
                      key={option.id}
                      className={
                        'feeds-filter__section' + (isFeedsListExpanded ? ' feeds-filter__section--expanded' : '')
                      }
                    >
                      {option.name && (
                        <div
                          className={
                            'feeds-filter__section-name' +
                            (isFeedsListExpanded ? ' feeds-filter__section-name--expanded' : '') +
                            (isHeaderScrolling ? ' feeds-filter__section-name--header-scrolling' : '')
                          }
                        >
                          {option.name}
                        </div>
                      )}
                      {option.attached_custom_feeds.map((item, subIndex) => {
                        return (
                          <Item
                            {...item}
                            text={item.custom_feed.name}
                            key={`${item.custom_feed.feed_url}-${subIndex}`}
                            mods={mods}
                            to={item.custom_feed.feed_url}
                            exact
                            isScrollingMode={isHeaderScrolling}
                            ui={ui}
                            isMouseEntered={isMouseEntered}
                            switchViewSettings={switchViewSettings}
                            switchViewOptions={switchViewOptions}
                            viewSettings={viewSettings}
                            switchOptionsShown={this.switchOptionsShown}
                            isCollectionViewBarShown={this.state.optionsShown}
                            type={type}
                          />
                        )
                      })}
                    </div>
                  )
                })}
              {isHome && feedsInSectionsFeeder.length ? (
                <div
                  className={'feeds-filter__section' + (isFeedsListExpanded ? ' feeds-filter__section--expanded' : '')}
                >
                  <div
                    className={
                      'feeds-filter__section-name' +
                      (isFeedsListExpanded ? ' feeds-filter__section-name--expanded' : '') +
                      (isHeaderScrolling ? ' feeds-filter__section-name--header-scrolling' : '')
                    }
                  >
                    Feeder
                  </div>
                  <div className="feeds-filter__section-items">
                    {feedsInSectionsFeeder.map(item => {
                      return (
                        <Item
                          {...item}
                          key={item.to}
                          mods={mods}
                          to={item.to}
                          exact
                          isScrollingMode={isHeaderScrolling}
                          ui={ui}
                          isMouseEntered={isMouseEntered}
                          switchViewSettings={switchViewSettings}
                          switchViewOptions={switchViewOptions}
                          viewSettings={viewSettings}
                          switchOptionsShown={this.switchOptionsShown}
                          isCollectionViewBarShown={this.state.optionsShown}
                          type={type}
                        />
                      )
                    })}
                  </div>
                </div>
              ) : null}
            </div>
            {isInProfile && (
              <div className="feeds-filter__section feeds-filter__add" onClick={this.switchMenu}>
                <DotMenu />
              </div>
            )}
          </div>
          <div className="feeds-filter__menu">
            <Fade mounted={this.state.isMenuOpen} time={150}>
              <SectionsMenu sections={customFeedSections} switchMenu={this.switchMenu} />
            </Fade>
          </div>
        </div>
        <ViewOptionsBar
          type={this.state.viewOptionsType}
          itemsOrder={this.state.itemsOrder}
          setOrder={this.setOrder}
          isCollectionViewBarShown={this.state.optionsShown}
          setKeyword={this.setKeyword}
          switchOptionsShown={this.switchOptionsShown}
          isHome={isHome}
          feedOptions={feedOptions}
        />
      </>
    )
  }
}

FeedSections.propTypes = {
  mods: pt.oneOfType([pt.string, pt.array]),
  options: pt.any,
  toggleFeedsFilter: pt.func,
  toggleFeedsHeight: pt.func,
  isFeedsListExpanded: pt.bool,
  isScrollingMode: pt.any,
  ui: pt.object,
  setKnobsPanelTopMargin: pt.func,
  isMouseEntered: pt.bool,
  hoverParent: pt.func,
  profileName: pt.string,
  isStatic: pt.bool,
  switchViewSettings: pt.func,
  switchViewOptions: pt.func,
  viewSettings: pt.object,
  user: pt.object,
  type: pt.string,
  isFloatingButtonPressed: pt.bool,
  isInProfile: pt.bool,
  isHome: pt.bool,
  requestCustomFeeds: pt.func,
  requestSavedFeeds: pt.func,
  requestPickedFeeds: pt.func,
  requestFeedsSavedToSectionsProfile: pt.func,
  requestFeedsSavedToSectionsFeeder: pt.func,
  requestCustomFeedSections: pt.func,
  feedsInSectionsFeeder: pt.array,
  profileId: pt.string,
  customFeedSections: pt.any
}

const makeMapStateToProps = () => {
  const getProfileUserByUsername = makeGetProfileUserByUsername()

  return (state, props) => {
    const getFeedById = makeGetFeedById()
    return {
      options: props.options
        .map(option => {
          return {
            option,
            feeds: option.get('feeds').map(feedId => {
              return getFeedById(state, feedId) || feedId
            })
          }
        })
        .toList()
        .sort((a, b) => a.option.get('position') - b.option.get('position')),
      ui: state.ui,
      user: get(state, 'user.data.user'),
      profileId: getProfileUserByUsername(state, props.profileName).get('id'),
      customFeedSections: get(state, 'myContent.customFeedSections'),
      feedsInSectionsFeeder: get(state, 'myContent.feedsInSectionsFeeder')
    }
  }
}

export default connect(
  makeMapStateToProps,
  {
    toggleFeedsFilter,
    toggleFeedsHeight,
    makeGetFeedById,
    setKnobsPanelTopMargin,
    requestCustomFeeds,
    requestSavedFeeds,
    requestPickedFeeds,
    requestFeedsSavedToSectionsProfile,
    requestFeedsSavedToSectionsFeeder,
    requestCustomFeedSections
  }
)(FeedSections)

export { Item as SectionsItem }
